import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './SkipToMainLink.scss';

const SkipToMainLink = ({ displayText }) => {
    const buttonEl = useRef(null);

    const focusElement = () => {
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
            mainContent.focus();
        } else {
            buttonEl.current.blur();
        }
    };

    return (
        <div className={styles.skipContent}>
            <button
                className={styles.skipContentButton}
                onClick={focusElement}
                ref={buttonEl}
            >
                { displayText }
            </button>
        </div>
    );
};

SkipToMainLink.propTypes = {
    displayText: PropTypes.string
};

export default SkipToMainLink;
